// extracted by mini-css-extract-plugin
export default {"contentContainer":"MainView_contentContainer__asrvx"};